import { ReactComponent as CursorEraserDark } from 'approot/shared/icons/icon_cursor_eraser_dark.svg';
import Icon, { IconProps } from './icon';

const IconCursorEraserDark = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={CursorEraserDark} />;
};

export default IconCursorEraserDark;
